<template>
  <div class="w-100">
    <div
      class="d-flex flex-column bet-slip-confirmation-row"
      v-for="(selection, index) in bet.bet.line_selections"
      :key="selection.id + '_' + index"
    >
      <div class="bet-slip-line-subheader m-0 bg-white">
        <div class="title d-flex flex-grow-1 flex-column">
          <div class="bold-title d-flex w-100 align-items-baseline">
            <div class="flex-grow-1 text-uppercase">
              {{ tryGetGameDescription(selection).market }}
            </div>
            <div class="d-flex ml-auto">
              <bet-slip-odds
                class="bet-slip-odd"
                :spread="selection.spread_after_points"
                :odds="selection.odds_after_points"
                :line="selection.line"
              ></bet-slip-odds>
            </div>
          </div>
          <div class="sub-text-color d-flex">
            <div class="flex-grow-1">
              {{ tryGetGameDescription(selection).selection }}
            </div>
          </div>
          <div class="sub-text-color" style="margin-right: 35px;">
            <span v-if="isLive(selection.selection_identifier)" class="d-inline-block mr-1">
              <live-icon></live-icon>
            </span>
            {{ tryGetGameDescription(selection).game }}
          </div>
        </div>
      </div>
    </div>
    <bet-accept-area :bet="bet" @accept="acceptBet" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { removeRotationNumberFromSelection, parseBetErrorMessage } from './bet-slip-utils';
import BetSlipOdds from './BetSlipOdds';
import { isLive } from '@/views/sports/components/bet-slip/check-bets';
import snq from 'snq';
import { trim } from 'lodash';
import LiveIcon from '@/views/sports/components/bet-slip/LiveIcon';
import BetAcceptArea from './BetAcceptArea';
import { getBetDescription } from './getBetDescription';

export default {
  props: ['bet'],
  components: {
    BetAcceptArea,
    BetSlipOdds,
    LiveIcon,
  },
  methods: {
    isLive,
    removeRotationNumberFromSelection,
    parseBetErrorMessage,
    ...mapMutations('betSlip', ['removeBetConfirmationId', 'addBetConfirmationId']),
    ...mapActions('betSlip', ['tryAddRejectedBet', 'tryRemoveRejectedBet']),
    onAcceptChange() {
      if (this.isAccepted) {
        this.removeBetConfirmationId(this.bet);
        this.tryAddRejectedBet(this.bet);
      } else {
        this.addBetConfirmationId(this.bet);
        this.tryRemoveRejectedBet(this.bet);
      }
    },
    accept() {
      this.addBetConfirmationId(this.bet);
      this.tryRemoveRejectedBet(this.bet);
    },
    remove() {
      this.removeBetConfirmationId(this.bet);
      this.tryAddRejectedBet(this.bet);
    },
    tryGetGameDescription(selection) {
      return getBetDescription(selection);
    },
    acceptBet() {
      this.accept();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../sass/variables';

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -5px;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: $green;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.custom-alert {
  border: 1px solid $red-dark;
  color: $red-dark;
  border-radius: 3px;
}
.accept-area {
  display: flex;
  align-items: center;

  .btn {
    width: 50%;
    cursor: pointer;

    &.remove-btn {
      height: 35px;
      line-height: 35px;
      text-align: left !important;
      color: #dc3545;
      padding: 0 !important;
      display: flex;
      align-items: center;
    }

    &.accept-btn {
      height: 35px;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #139000 !important;
      }

      &.active {
        background-color: rgba(56, 172, 38, 0.5) !important;
        box-shadow: 0 0 0 3px rgba(56, 172, 38, 0.1);
      }
    }
  }
}
</style>
